import React from 'react'

const Undo = ({ className, size, disabled }) => {
  return (
    <svg
      width={`${size ? size : '31'}`}
      height={`${size ? size : '31'}`}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15.5"
        cy="15.5"
        r="15.5"
        fill="#3D3D3D"
        fillOpacity={disabled ? '0.3' : '0.96'}
      />
      <path
        d="M12.5674 13.5391C13.3332 12.838 14.7007 11.9752 15.8459 11.9752C18.1997 11.9752 20.1079 13.7957 20.1079 16.0415C20.1079 18.2872 18.1997 20.1078 15.8459 20.1078C14.7007 20.1078 13.661 19.6769 12.8952 18.9757M12.5674 13.5391L13.5509 10.0537M12.5674 13.5391L15.518 14.0753"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Undo
